var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.languages).length > 0)?_c('at-select',{attrs:{"value":_vm.value},on:{"on-change":function($event){return _vm.inputHandler($event)}}},_vm._l((_vm.languages),function(lang,index){return _c('at-option',{key:index,attrs:{"value":lang.value}},[_vm._v("\n        "+_vm._s(lang.label)+"\n    ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }